<template>
  <div class="my-order" ref="container">
    <div class="header bg-color-red">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="text">
          <div class="name">订单信息</div>
          <div>
            累计订单：{{ orderData.total_count || 0 }} 总消费：￥{{
              orderData.total_price || 0
            }}
          </div>
        </div>
        <div class="pictrue"><img src="@assets/images/orderTime.png" /></div>
      </div>
    </div>
    <div class="nav acea-row row-around">
      <div
        class="item"
        :class="{ on: type === 100 }"
        @click="$router.replace({ path: '/order/list/100' })"
      >
        <div>全部</div>
        <div class="num">{{ orderData.total_count || 0 }}</div>
      </div>
      <div
        class="item"
        :class="{ on: type === 0 }"
        @click="$router.replace({ path: '/order/list/0' })"
      >
        <div>待付款</div>
        <div class="num">{{ orderData.WAIT_PAY || 0 }}</div>
      </div>
      <div
        class="item"
        :class="{ on: type === 1 }"
        @click="$router.replace({ path: '/order/list/1' })"
      >
        <div>待发货</div>
        <div class="num">{{ orderData.PAY_SUCCESS || 0 }}</div>
      </div>
      <div
        class="item"
        :class="{ on: type === 9 }"
        @click="$router.replace({ path: '/order/list/9' })"
      >
        <div>待收货</div>
        <div class="num">{{ orderData.SEND_OUT_GOODS || 0 }}</div>
      </div>
      <!--<div-->
      <!--class="item"-->
      <!--:class="{ on: type === 3 }"-->
      <!--@click="$router.replace({ path: '/order/list/3' })"-->
      <!--&gt;-->
      <!--<div>待评价</div>-->
      <!--<div class="num">{{ orderData.evaluated_count || 0 }}</div>-->
      <!--</div>-->
      <!--<div-->
      <!--class="item"-->
      <!--:class="{ on: type === 4 }"-->
      <!--@click="$router.replace({ path: '/order/list/4' })"-->
      <!--&gt;-->
      <!--<div>已完成</div>-->
      <!--<div class="num">{{ orderData.complete_count || 0 }}</div>-->
      <!--</div>-->
    </div>
    <div class="list">
      <div
        class="item"
        v-for="(order, order_index) in orderList"
        :key="order.id"
      >
        <div class="title acea-row row-between-wrapper">
          <div class="acea-row row-middle">
            <span
              class="sign cart-color acea-row row-center-wrapper"
              v-if="order.combination_id > 0"
              >拼团</span
            ><span
              class="sign cart-color acea-row row-center-wrapper"
              v-if="order.seckill_id > 0"
              >秒杀</span
            ><span
              class="sign cart-color acea-row row-center-wrapper"
              v-if="order.bargain_id > 0"
              >砍价</span
            >
            {{ order.add_time }}
          </div>
          <div class="font-color-red">{{ order.status_msg || "订单状态" }}</div>
        </div>
        <div @click="$router.push({ path: '/order/detail/' + order.id })">
          <div
            class="item-info acea-row row-between row-top"
            v-for="(cart, index) in order.snapshot"
            :key="index"
          >
            <div class="pictrue rel">
              <img
                v-if="cart.is_gift"
                class="abs gift-logo"
                src="//aijiutang.oss-cn-beijing.aliyuncs.com/work_time/assets/images/gift_icon.png"
              />
              <img
                :src="cart.productInfo.img"
                @click.stop="
                  $router.push({ path: '/detail/' + cart.productInfo.id })
                "
                v-if="cart.productInfo.img"
              />
              <img
                v-else
                src="@assets/images/noGood.png"
                @click.stop="
                  $router.push({ path: '/detail/' + cart.productInfo.id })
                "
              />
            </div>
            <div class="text acea-row row-between">
              <div class="name line2">
                {{ cart.productInfo.title || "" }}
                <span v-if="cart.is_gift" class="gift">{{
                  cart.gift_msg ||
                    (cart.is_gift == 1
                      ? "赠品"
                      : cart.is_gift == 2
                      ? "买一送一"
                      : "买二送一")
                }}</span>
              </div>
              <div class="money">
                <div>￥{{ cart.truePrice }}</div>
                <div>x{{ cart.cart_num }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="totalPrice">
          共{{ order.snapshot.length || 0 }}件商品，<span
            v-if="order.pay_postage"
            >运费 ￥{{ order.pay_postage }}，</span
          >总金额
          <span class="money font-color-red">￥{{ order.pay_price }}</span>
        </div>
        <div class="bottom acea-row row-right row-middle">
          <template v-if="order.status_code === 'WAIT_PAY'">
            <div class="bnt cancelBnt" @click="cancelOrder(order)">
              取消订单
            </div>
            <div class="bnt bg-color-red" @click="paymentTap(order)">
              立即付款
            </div>
          </template>
          <template
            v-if="
              order.status === 1 ||
                order.status === 2 ||
                order.status === 3 ||
                order.status === 9
            "
          >
            <div
              class="bnt bg-color-red"
              @click="returnOfGoods(order, order_index)"
            >
              退货
            </div>
          </template>

          <template v-if="order.status_code === 'SEND_OUT_GOODS'">
            <div
              class="bnt default"
              @click="$router.push({ path: '/order/logistics/' + order.id })"
            >
              查看物流
            </div>
            <div class="bnt bg-color-red" @click="takeOrder(order)">
              确认收货
            </div>
          </template>
          <!--<template v-if="order._status._type === 3">-->
          <!--<div-->
          <!--class="bnt default"-->
          <!--@click="-->
          <!--$router.push({ path: '/order/logistics/' + order.id })-->
          <!--"-->
          <!--v-if="order.delivery_type === 'express'"-->
          <!--&gt;-->
          <!--查看物流-->
          <!--</div>-->
          <!--<div-->
          <!--class="bnt bg-color-red"-->
          <!--@click="$router.push({ path: '/order/detail/' + order.id })"-->
          <!--&gt;-->
          <!--去评价-->
          <!--</div>-->
          <!--</template>-->
        </div>
      </div>
    </div>
    <div class="noCart" v-if="orderList.length === 0 && page > 1">
      <div class="pictrue"><img src="@assets/images/noOrder.png" /></div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
    <Payment
      v-model="pay"
      :types="payType"
      @checked="toPay"
      :balance="userInfo.now_money"
    ></Payment>
  </div>
</template>
<script>
import { getOrderData, getOrderList } from "@api/order";
import {
  cancelOrderHandle,
  payOrderHandle,
  takeOrderHandle
} from "@libs/order";
import Loading from "@components/Loading";
import Payment from "@components/Payment";
import { mapGetters } from "vuex";
import { isWeixin } from "@utils";

const NAME = "MyOrder";

export default {
  name: NAME,
  data() {
    return {
      offlinePayStatus: 2,
      orderData: {},
      type: parseInt(this.$route.params.type) || 0,
      page: 1,
      limit: 20,
      loaded: false,
      loading: false,
      orderList: [],
      pay: false,
      payType: ["yue", "weixin"],
      from: isWeixin() ? "weixin" : "weixinh5"
    };
  },
  components: {
    Loading,
    Payment
  },
  computed: mapGetters(["userInfo"]),
  watch: {
    $route(n) {
      if (n.name === NAME) {
        const type = parseInt(this.$route.params.type) || 0;
        if (this.type !== type) {
          this.changeType(type);
        }
        this.getOrderData();
      }
    }
  },
  methods: {
    returnOfGoods(order) {
      let message = [
        { status: 1, msg: "确定要退货吗？" },
        {
          status: 2,
          msg: "当前订单商品已经出库，受数据更新的影响，请联系客服协助退货"
        },
        {
          status: 3,
          msg:
            "当前订单商品已经出库待发货，受数据更新的影响，请联系客服协助退货"
        },
        {
          status: 9,
          msg: "当前订单已经发货，退货需用户自行承担退回路费，确定退货吗？"
        }
      ];
      let that = this;
      console.log("return of goods", order);
      this.$dialog.confirm({
        mes:
          message.find(item => item.status == order.status).msg ||
          "退货需用户自行承担退回路费，确定退货吗？",
        opts: [
          {
            txt: "确定退货",
            color: false,
            callback: () => {
              console.log("确定退货e", order, "/order/refund/" + order.id);
              that.$router.push({ path: "/order/refund/" + order.id });
            }
          },
          { txt: "再想想" }
        ]
      });
    },
    setOfflinePayStatus: function(status) {
      var that = this;
      that.offlinePayStatus = status;
      if (status === 1) {
        if (that.payType.indexOf("offline") < 0) {
          that.payType.push("offline");
        }
      }
    },
    getOrderData() {
      getOrderData().then(res => {
        this.orderData = res.data;
      });
    },
    takeOrder(order) {
      takeOrderHandle(order.id).finally(() => {
        this.reload();
        this.getOrderData();
      });
    },
    reload() {
      this.changeType(this.type);
    },
    changeType(type) {
      this.type = type;
      this.orderList = [];
      this.page = 1;
      this.loaded = false;
      this.loading = false;
      this.getOrderList();
    },
    getOrderList() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      const { page, limit, type } = this;
      getOrderList({
        page,
        page_size: limit,
        status: type
      }).then(res => {
        this.loading = false;
        if (!res.data) {
          this.loaded = true;
          return;
        }
        this.orderList = this.orderList.concat(res.data);
        this.page++;
        this.loaded = res.data.length < this.limit;
      });
    },
    // getStatus(order) {
    //   return STATUS[order.status_];
    // },
    cancelOrder(order) {
      cancelOrderHandle({ id: order.id })
        .then(() => {
          this.orderList.splice(this.orderList.indexOf(order), 1);
        })
        .catch(() => {
          this.reload();
        });
    },
    paymentTap: function(order) {
      var that = this;
      if (
        !(
          order.combination_id > 0 ||
          order.bargain_id > 0 ||
          order.seckill_id > 0
        )
      ) {
        that.setOfflinePayStatus(order.offlinePayStatus);
      }
      this.pay = true;
      this.toPay = type => {
        payOrderHandle(order.id, type, that.from)
          .then(() => {
            const type = parseInt(this.$route.params.type) || 0;
            that.changeType(type);
            that.getOrderData();
          })
          .catch(res => {
            console.log("WECHAT_H5_PAY", res);
            if (res && res.status === "WECHAT_H5_PAY")
              return that.$router.push({
                path: "/order/status/" + order.id + "/0"
              });
            const type = parseInt(that.$route.params.type) || 0;
            that.changeType(type);
            that.getOrderData();
          });
      };
    },
    toPay() {}
  },
  mounted() {
    this.getOrderData();
    this.getOrderList();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getOrderList();
    });
  }
};
</script>

<style scoped>
.noCart {
  margin-top: 0.17rem;
  padding-top: 0.1rem;
}
.gift {
  background: red;
  color: #ffffff;
  padding: 2px 5px;
  font-size: 0.2rem;
  margin-left: 0.1rem;
}
.my-order .list .item .item-info .pictrue img.gift-logo {
  left: 0;
  top: 0;
  width: 0.5rem;
  height: 0.5rem;
}
.noCart .pictrue {
  width: 4rem;
  height: 3rem;
  margin: 0.7rem auto 0.5rem auto;
}

.noCart .pictrue img {
  width: 100%;
  height: 100%;
}
</style>
